var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"space-admin"},[_c('h1',[_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.admin.title")))]),_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('Menu',{on:{"change":_vm.onChange}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }